import { render, staticRenderFns } from "./Modality.vue?vue&type=template&id=2256d122&scoped=true&"
import script from "./Modality.vue?vue&type=script&lang=js&"
export * from "./Modality.vue?vue&type=script&lang=js&"
import style0 from "./Modality.vue?vue&type=style&index=0&id=2256d122&lang=scss&scoped=true&"
import style1 from "./Modality.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2256d122",
  null
  
)

export default component.exports